var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileInner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 650,
    viewBox: "0 0 320 650",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 43.2073C0 19.5444 20.088 0.361816 44.8677 0.361816H275.132C299.912 0.361816 320 19.5444 320 43.2073V606.665C320 630.328 299.912 649.511 275.132 649.511H44.8677C20.088 649.511 0 630.328 0 606.665V43.2073Z",
    fill: "#10141B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileInner);
export default __webpack_public_path__ + "static/media/mobileInner.a2d0053cb359df77045653facad10bc2.svg";
export { ForwardRef as ReactComponent };